import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import cn from 'classnames'

import CategoriesList from 'components/Categories/List'

import { getBannerIsOpen } from 'store/AppState/selector'

const Categories = () => {
  const { state: urlQueryParamsState } = useLocation()
  const isBannerOpen = useSelector((state) =>
    getBannerIsOpen(state, 'categories')
  )

  return (
    <div className="items">
      <div className={cn('header', { '-isBanner': isBannerOpen })}>
        <ul className="header__menu">
          <li className="header__menu-item">Name</li>
          <li className="header__menu-item">Assigned Items</li>
          <li className="header__menu-item">Color</li>
        </ul>
      </div>
      <CategoriesList key={urlQueryParamsState?.categoryUuid} />
    </div>
  )
}

Categories.propTypes = {}

export default Categories
